// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1-8r8","newExpiryDate":"styles_newExpiryDate__2SQYK","footer":"styles_footer__ZJMVA"};